(function () {
    'use strict';

    angular.module('app.consulting', ['ngRoute','ui.calendar']);
})();